import moment from "moment";
require("moment/min/locales.min");

export { debounce, clearDebounce } from "./DebounceUtils";

export const secondsToMin = (sec) => {
    return sec ? Math.floor(sec / 60) : 0;
}

export let nFormatter = (num) => {
    if (!Number.isNaN(num)) {
        if (num >= 1000000000) {
            return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
        }
        if (num >= 1000000) {
            return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
        }
        if (num >= 1000) {
            return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
        }
        return num;
    }
}

export let getXLegende = (period, intl) => {
    switch (period) {
        case "currentday":
            return moment().format("D MMMM YYYY");
        case "previousday":
            return moment().subtract(1, "days").format("D MMMM YYYY");
        case "currentweek":
            return intl.messages.week + " " +
                moment().isoWeeks();
        case "previousweek":
            return intl.messages.week + " " +
                moment().subtract(1, "week").startOf("isoWeek").format("W")
        case "currentmonth":
            return moment().format("MMMM YYYY");
        case "previousmonth":
            return moment().subtract(1, "months").format("MMMM YYYY");
        case "currentyear":
            return moment().format("YYYY");
        default:
            return period;
    }
};

export let getPeriodDate = metricPeriod => {
    let fromDay = null;
    let toDay = null;
    let period = "hour";

    moment.updateLocale("en-US", {
        week: {
            dow: 1,
            doy: 4
        }
    });

    switch (metricPeriod) {
        case "currentday":
            fromDay = moment().startOf("day").toString();
            toDay = moment().endOf("day").toString();
            period = "hour";
            break;
        case "previousday":
            fromDay = moment().subtract(1, "day").startOf("day").toString();
            toDay = moment().subtract(1, "day").endOf("day").toString();
            period = "hour";
            break;
        case "currentweek":
            fromDay = moment().startOf("week").toString();
            toDay = moment().endOf("week").toString();
            period = "day";
            break;
        case "previousweek":
            fromDay = moment().subtract(1, "week").startOf("week").toString();
            toDay = moment().subtract(1, "week").endOf("week").toString();
            period = "day";
            break;
        case "currentmonth":
            period = "day";
            fromDay = moment().startOf("month").toString();
            toDay = moment().endOf("month").toString();
            break;
        case "previousmonth":
            period = "day";
            fromDay = moment().subtract(1, "month").startOf("month").toString();
            toDay = moment().subtract(1, "month").endOf("month").toString();
            break;
        case "currentyear":
            fromDay = moment().startOf("year").toString();
            toDay = moment().endOf("year").toString();
            period = "month";
            break;

        default:
            /* code */
            break;
    }

    return {
        period: period,
        toDay: toDay,
        fromDay: fromDay
    };
};

export let getStartPeriod = (period, intl) => {
    let momDate = moment();
    moment.locale(intl.locale);

    switch (period) {
        case "currentday":
            return momDate.startOf("day").format("LT");
        case "previousday":
            return momDate.subtract(1, "day").startOf("day").format("LT");
        case "currentweek":
            return momDate.startOf("isoWeek").format("LL");
        case "previousweek":
            return momDate.subtract(1, "week").startOf("isoWeek").format("LL");
        case "currentmonth":
            return momDate.startOf("month").format("LL");
        case "previousmonth":
            return momDate.subtract(1, "month").startOf("month").format("LL");
        case "currentyear":
            return momDate.startOf("year").format("LL");
        default:
            return "";
    }
};

export let getEndPeriod = (period, intl) => {
    let momDate = moment();
    moment.locale(intl.locale);

    switch (period) {
        case "currentday":
            return momDate.endOf("day").format("LT");
        case "previousday":
            return momDate
                .subtract(1, "day").endOf("day").format("LT");
        case "currentweek":
            return momDate.endOf("isoWeek").format("LL");
        case "previousweek":
            return momDate.subtract(1, "week").endOf("isoWeek").format("LL");
        case "currentmonth":
            return momDate.endOf("month").format("LL");
        case "previousmonth":
            return momDate.subtract(1, "month").endOf("month").format("LL");
        case "currentyear":
            return momDate.endOf("year").format("LL");
        default:
            return "";
    }
};

export let dateFormatter = (period) => {
    switch (period) {
        case "currentday":
        case "previousday":
            return "dd MMMM HH:mm";

        case "previousweek":
        case "currentweek":
        case "previousmonth":
        case "currentmonth":
            return "dd MMMM yyyy";

        case "currentyear":
            return "MMMM yyyy";

        default:
            return "dd MMM";
    }
}

export let getPeriodUnit = (period) => {
    let formatedPeriod = "week";

    switch (period) {
        case "currentday":
        case "previousday":
        case "currentweek":
        case "previousweek":
            formatedPeriod = "day";
            break;
        case "currentmonth":
        case "previousmonth":
        case "currentyear":
            formatedPeriod = "month";
            break;
        default:
            formatedPeriod = "day";
            break;
    }
    return formatedPeriod;
};

export const prepareExportableAnalytics = (data) => {
    const result = [];

    const headers = {
        date: ""
    };

    // compute the complete list of headers.
    data.map(item => {
        if (item.aggregationStartDate) {
            if (item.groupCounters) {
                item.groupCounters.map(counter => {
                    headers[counter.group] = 0;
                });
            }
        }
    });

    // now we have a template header with all the headers returned in what ever day occurred, 
    // make a second pass to fill in the array with the actual contents
    data.map(item => {
        const line = { ...headers };
        if (item.aggregationStartDate) {
            // date goes to a "date column"
            line.date = item.aggregationStartDate;
            if (item.groupCounters) {
                item.groupCounters.map(counter => {
                    line[counter.group] = counter.count;
                });
            }
            result.push(line);
        }
    });

    return result;
}

export const consolidateAnalytics = (data, mappings) => {
    let consolidatedData = [];

    let consolidatedGraphData = {
        administration: [],
        resources: [],
        turn: [],
        webrtc_minutes: [],
        storage: [],
        labels: []
    };
    let consolidatedCumulGraphData = {
        administration: [],
        resources: [],
        turn: [],
        storage: [],
        webrtc_minutes: [],
        labels: []
    };

    let cumulated = {
        administration: 0,
        resources: 0,
        turn: 0,
        storage: 0,
        webrtc_minutes: 0,
    }

    data.map(analytic => {
        let line = {
            date: analytic.aggregationStartDate,
            administration: 0,
            resources: 0,
            turn: 0,
            storage: 0,
            webrtc_minutes: 0
        };

        if (analytic.groupCounters) {
            analytic.groupCounters.map(counter => {
                let found = false;
                Object.keys(mappings).map(group => {
                    if (mappings[group].includes(counter.group)) {
                        line[group] += counter.count;
                        found = true;
                    }
                })

                // if (!found) {
                //     LogService.warn(name, "consolidateAnalytics", "Unknown group " + counter.group);
                // }
            });
        }

        Object.keys(mappings).map(group => {
            consolidatedGraphData[group].push(line[group]);
            consolidatedCumulGraphData[group].push(line[group] + cumulated[group]);
            cumulated[group] += line[group];
        });

        consolidatedGraphData.labels.push(analytic.aggregationStartDate);
        consolidatedCumulGraphData.labels.push(analytic.aggregationStartDate);
        consolidatedData.push(line);
    });


    return {
        data: consolidatedData,
        graphData: consolidatedGraphData,
        cumulGraphData: consolidatedCumulGraphData,
        totalCumulAdministration: cumulated.administration,
        totalCumulResources: cumulated.resources,
        totalCumulTurn: cumulated.turn,
        totalCumulStorage: cumulated.storage,
        totalCumulTraffic: cumulated.webrtc_minutes
    };
};

export const consolidateThresholds = (analytics, mappings) => {
    const cumulated = {
        administration: 0,
        resources: 0,
        turn: 0,
        storage: 0,
        webrtc_minutes: 0,
    }

    analytics.map(analytic => {
        if (analytic.groupCounters) {
            analytic.groupCounters.map(counter => {
                let found = false;
                Object.keys(mappings).map(group => {
                    if (mappings[group].includes(counter.group)) {
                        cumulated[group] += counter.count;
                        found = true;
                    }
                })
            });
        }
    });

    return {
        ...cumulated
    };
}
